export default __webpack_public_path__ + "static/media/gallery - polyjuice_02.4ed1756c.jpg";